/**
 * @generated SignedSource<<2109e67a25f21dbc63311932ffdcedab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IncludedLabels_item$data = {
  readonly attributes: {
    readonly framingStatus: ReadonlyArray<{
      readonly value: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"useItemPriceData_item">;
  readonly " $fragmentType": "IncludedLabels_item";
};
export type IncludedLabels_item$key = {
  readonly " $data"?: IncludedLabels_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"IncludedLabels_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IncludedLabels_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemPriceData_item"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemAttributes",
      "kind": "LinkedField",
      "name": "attributes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeValue",
          "kind": "LinkedField",
          "name": "framingStatus",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "1ffbe2f3a4b3d8d6e3ffe8037cbdf336";

export default node;
